import React from "react";

import { TableCreatorSubGroupGroupShellList } from "@FillInTableContainer/shared/types/tableCreator.types";

import DealsKeyCommentMaCreatorGroupShell from "./components/DealsKeyCommentMaCreatorGroupShell/DealsKeyCommentMaCreatorGroupShell";

import type { DealsSection } from "@/types/deals.types";

interface Props {
  groupTableKey: DealsSection;
  tableKey: string | null;
  groupShellList: TableCreatorSubGroupGroupShellList;
  groupTableIndex: number;
  tableIndex: number;
}

const DealsKeyCommentMaCreatorTable = ({
  groupTableKey,
  tableKey,
  groupTableIndex,
  tableIndex,
  groupShellList,
}: Props) => {
  return (
    <>
      {groupShellList.map(
        ({ groupShellKey, subGroupShellList }, groupShellListIndex) => (
          <DealsKeyCommentMaCreatorGroupShell
            key={`group-shell-${String(groupTableIndex)}-${String(
              tableIndex,
            )}-${String(groupShellListIndex)}`}
            subGroupShellList={subGroupShellList}
            groupTableKey={groupTableKey}
            groupTableIndex={groupTableIndex}
            tableKey={tableKey}
            tableIndex={tableIndex}
            groupShellKey={groupShellKey}
            groupShellIndex={groupShellListIndex}
          />
        ),
      )}
    </>
  );
};

export default DealsKeyCommentMaCreatorTable;
